import {Alert, CircularProgress, Stack} from '@mui/material';
import type * as React from 'react';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Header from '@/components/Header';
import {useUserContext} from '@/components/Providers/UserContext';

const SignOut = () : React.ReactElement => {
    const navigate = useNavigate();
    const {user, signOut} = useUserContext();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (user !== null && user !== undefined) {
            signOut();
            window.location.reload();
        }
    }, []);

    useEffect(() => {
        if (user === null) {
            setLoading(false);
            navigate('/');
        }
    }, [user]);

    return <Stack
        direction='column'
        sx={{
            backgroundColor: '#631d79',
            height: '100%',
        }}
    >
        <Header/>
        {loading && <Alert severity='info'>Signing Out</Alert> }
        <CircularProgress/>
    </Stack>;
};

export default SignOut;
